import { render, staticRenderFns } from "./DatosLegajoSimple.vue?vue&type=template&id=6bda5a5b"
import script from "./DatosLegajoSimple.vue?vue&type=script&lang=js"
export * from "./DatosLegajoSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports